import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'

// Store functionality
import modules from './modules'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    auth: {
      token: state.auth.token,
      user: state.auth.user,
      identification: state.auth.identification,
      identificationType: state.auth.identificationType,
      namePatient: state.auth.namePatient
    }
  })
})

// Create a new store
export default new Vuex.Store({
  modules,
  plugins: [vuexLocal.plugin]
})
